import { useEffect, useRef } from 'react';

let activeLocks = 0;
let originalOverflow = '';
let originalHtmlOverflow = '';

export const useBodyScrollLock = (locked) => {
  const ownsLock = useRef(false);

  useEffect(() => {
    if (!locked || typeof document === 'undefined') return undefined;

    if (activeLocks === 0) {
      originalOverflow = document.body.style.overflow;
      originalHtmlOverflow = document.documentElement.style.overflow;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    activeLocks += 1;
    ownsLock.current = true;

    return () => {
      if (!ownsLock.current) return;

      activeLocks = Math.max(0, activeLocks - 1);
      ownsLock.current = false;

      if (activeLocks === 0) {
        document.body.style.overflow = originalOverflow;
        document.documentElement.style.overflow = originalHtmlOverflow;
      }
    };
  }, [locked]);
};
